function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("g", {
  id: "times-light",
  transform: "translate(9.818182 9.818182)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "",
  d: "M0.1-1.64l5.24-5.24l1.08-1.08c0.16-0.16,0.16-0.42,0-0.58L5.27-9.7c-0.16-0.16-0.42-0.16-0.58,0 l-6.33,6.33L-7.96-9.7c-0.16-0.16-0.42-0.16-0.58,0L-9.7-8.54c-0.16,0.16-0.16,0.42,0,0.58l6.33,6.33L-9.7,4.69 c-0.16,0.16-0.16,0.42,0,0.58l1.16,1.16c0.16,0.16,0.42,0.16,0.58,0l6.33-6.33l5.24,5.24l1.08,1.08c0.16,0.16,0.42,0.16,0.58,0 l1.16-1.16c0.16-0.16,0.16-0.42,0-0.58L0.1-1.64z"
})));
var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.36 16.36",
    style: {
      enableBackground: "new 0 0 16.36 16.36"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.9f68f0ee.svg";
export { ForwardRef as ReactComponent };